export const getApiUrl = (): string => {
  const protocol = process.env.REACT_APP_HTTP_PROTOCOL;
  return `${protocol ?? "http"}://${
    process.env.REACT_APP_API_URL ?? "localhost:8000"
  }`;
};

export const getApiUrlWS = (): string => {
  const protocol = process.env.REACT_APP_WEBSOCKET_PROTOCOL;
  return `${protocol ?? "ws"}://${
    process.env.REACT_APP_API_URL ?? "localhost:8000"
  }`;
};
